/* eslint-disable
    func-names,
    max-len,
    no-sequences,
    no-unused-expressions,
    no-unused-vars,
    one-var,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS201: Simplify complex destructure assignments
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const deps = ['$scope', 'DocumentCollection', 'Document', 'LedgerCollection', '$state'];

const StatementCardCtrl = function (
  $scope,
  DocumentCollection,
  DocumentModel,
  LedgerCollection,
  $state,
) {
  let adjustedLength, array, day;
  this.years = _.range(2010, new Date().getFullYear() + 1).reverse();

  // decode the date
  (array = this.date.split('-')),
    (adjustedLength = Math.max(array.length, 1)),
    ([this.month, day] = Array.from(array.slice(0, adjustedLength - 1))),
    (this.year = array[adjustedLength - 1]);
  this.selectYear = function (year) {
    return $state.go('bench.dms.statements.ledger', {
      clientId: this.clientId,
      ledgerId: this.ledgerId,
      date: year,
    });
  };

  this.months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ];

  this.statements = new DocumentCollection({
    clientId: this.clientId,
    documentType: 'STATEMENT',
    ledgerId: this.ledgerId,
    year: this.year,
  }).$cacheAllModels();

  this.monthlyStatements = _.reduce(
    this.months,
    (acc, month, i) => {
      const monthlyStatements = this.statements.$filter(model => model.month === i + 1);
      monthlyStatements.documentType = 'STATEMENT';
      monthlyStatements.$listen(this.statements);
      monthlyStatements.$cacheAllModels();
      acc[month] = monthlyStatements;
      return acc;
    },
    {},
  );

  const ledgers = new LedgerCollection(this.clientId);
  this.getLedger = () => ledgers.$findById(this.ledgerId);

  this.saveStatus = statement =>
    // TODO: update to use viewModels
    statement.$put(statement.$data());
  this.selectedDocuments = new DocumentCollection({
    $id: `${this.statements.$storeId()}-Selected`,
    $lastUpdated: 1,
  });
  this.selectedDocuments.documentType = 'STATEMENT';
  this.selectedDocuments.$useCachedModels = true;
  this.selectedDocuments.$empty();

  this.onCheck = (checked, id) => {
    if (checked) {
      const selectedDocument = new DocumentModel(id);
      return this.selectedDocuments.$add(selectedDocument);
    }
    return this.selectedDocuments.$removeById(id);
  };

  this.isChecked = document => !_.isUndefined(this.selectedDocuments.$findById(document.id));

  this.selectAll = checked => {
    if (checked) {
      return this.selectedDocuments.$set(this.statements.$data());
    }
    return this.selectedDocuments.$empty();
  };
};

StatementCardCtrl.$inject = deps;

module.exports = StatementCardCtrl;
